import React, { useEffect, useState } from "react";
import Popup from "reactjs-popup";
import { MediaUrl } from "./Media";
import { isBrowser } from "react-device-detect";

export default function ShowImage({imgObject,trigger_size={width:'100%',height:'100%'},on_remove=()=>{}})
{
    const [image_,setImageObject] = useState(null);
    useEffect(()=>{
        try{
            setImageObject(URL.createObjectURL(imgObject));
        }
        catch{
            setImageObject(MediaUrl(imgObject.image));
        }
        
    },[imgObject])
    return(
        <Popup trigger={<div style={{position:'relative',height:trigger_size.height,width:trigger_size.width}}>
                        <label onClick={e=>{on_remove();}} style={{position:'absolute',top:'2px',right:'0px',backgroundColor:'rgba(0,0,0,0.6)',color:'white',padding:'0px 0px 2px 3px',borderRadius:'3px',fontSize:'x-small'}}>x</label>
                        <img src={image_} style={{height:'100%',width:'100%'}} />
                    </div>}>
                     { close=>(
                        <div style={{position:'fixed',top:'0',left:'0',width:'100%',height:'100vh',backgroundColor:'rgba(0,0,0,0.8)'}}>
                            <div style={{backgroundColor:'white',padding:'20px',borderRadius:'20px',position:'absolute',top:'50%',left:'50%',transform:'translate(-50%,-50%)',width: isBrowser?'50%':'80%',height:'fit-content'}}>
                                <label onClick={()=>{close();}} style={{position:'absolute',top:'20px',right:'20px',backgroundColor:'rgba(0,0,0,0.6)',color:'white',padding:'5px 5px 5px 5px',borderRadius:'3px',fontSize:'x-small',cursor:'pointer'}}>x</label>
                                <img src={image_} style={{width:'100%',margin:'auto'}} />
                            </div>
                        </div>
                     )}

        </Popup>
    );
}